import { gql } from 'urql';

export const LIST_SLA = gql`
  query ListSla($pagination: PaginationInput, $filters: SlaDefFilterInput) {
    listSLA(pagination: $pagination, filters: $filters) {
      items {
        id
        nombre
        tipoServicio
        zona
        promesaHoras
        primeraRespuestaMin
        activo
        creadoEn
        actualizadoEn
      }
      pageInfo {
        total
        limit
        offset
      }
    }
  }
`;

export const GET_SLA = gql`
  query GetSla($id: ID!) {
    getSLA(id: $id) {
      id
      nombre
      tipoServicio
      zona
      promesaHoras
      primeraRespuestaMin
      activo
      creadoEn
      actualizadoEn
    }
  }
`;

export const CREAR_SLA = gql`
  mutation CrearSla($input: CrearSlaInput!) {
    crearSLA(input: $input) {
      id
      nombre
    }
  }
`;

export const ACTUALIZAR_SLA = gql`
  mutation ActualizarSla($id: ID!, $input: ActualizarSlaInput!) {
    actualizarSLA(id: $id, input: $input) {
      id
      nombre
      tipoServicio
      zona
      promesaHoras
      primeraRespuestaMin
      activo
    }
  }
`;

export const ACTIVAR_SLA = gql`
  mutation ActivarSla($id: ID!, $activo: Boolean!) {
    activarSLA(id: $id, activo: $activo) {
      id
      activo
    }
  }
`;
